import { States } from "../../../../../../constants";

export const validStateOptions: string[] = [];
States.forEach((state) => validStateOptions.push(state.name));

export const gender = ["Male", "Female"];

export const maritalStatus = ["Married", "Un-Married", "Widowed"];

export const races = ["African-American", "Caucasian", "Hispanic", "Other"];

export const acquisitionTypeOptions = [
  "Off-Market",
  "On-Market",
  "Joint venture with land owner",
  "Other",
];

export const siteControlStatusOptions = [
  "LOI Obtained",
  "Purchase Contract Executed",
  "RFP Submitted",
  "Exclusive Negotiating Period Entered Into",
  "Other",
];

export const projectByRightOptions = ["Yes", "No", "Not Yet Determined"];

export const neighborhoods = [
  "Avenues West",
  "Baran Park",
  "Bluemound Heights",
  "Bradley Estates",
  "Brewer's Hill",
  "Clarke Square",
  "Clayton Crest",
  "Clock Tower Acres",
  "Bluemound Heights",
  "Dineen Park",
  "Downer Woods",
  "East Town",
  "Enderis Park",
  "Grasslyn Manor",
  "Holler Park",
  "Honey Creek Manor",
  "Honey Creek Parkway",
  "Halyard Park",
  "Havenwoods",
  "Hawley Farms",
  "Hightwood Estates",
  "Historic Third Ward",
  "Jones' Island",
  "Kops Park",
  "Lindsay Heights",
  "Martin Drive",
  "McGovern Park",
  "Menomonee River Hills",
  "Menomonee Valley",
  "Miller Valley",
  "Milwaukee River Parkway",
  "Mount Mary",
  "Muskego Way",
  "Northridge Lakes",
  "Old North Milwaukee",
  "Riverton Heights",
  "Riverwest",
  "Root Creek",
  "Saveland Park",
  "Schlitz Park",
  "Servite Woods",
  "Story Hill",
  "The Gateway to Milwaukee",
  "The Valley Pigville",
  "Timmerman West",
  "Walker's Point",
  "Wahi Park",
  "Westown",
  "Wick Field",
  "Williamsburg Heights",
  "Wilson Park",
  "Wyrick Park",
];
